import { render } from "./ObjectDocuments.vue?vue&type=template&id=7d516a7d&scoped=true"
import script from "./ObjectDocuments.vue?vue&type=script&lang=js"
export * from "./ObjectDocuments.vue?vue&type=script&lang=js"

import "./ObjectDocuments.vue?vue&type=style&index=0&id=7d516a7d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d516a7d"

export default script